import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import API from '@aws-amplify/api';
import queryString from 'query-string';
import Nav from './components/nav/nav.component';
import Hacker from './routes/hacker/hacker';
import Mentor from './routes/mentor/mentor';
import Judge from './routes/judge/judge';
import Workshops from './routes/workshops/workshops';
import Home from './routes/home/home';
import Admin from './routes/admin/admin';
import Hardware from './routes/hardware/hardware';
import Boba from './routes/boba/boba';
import Setup from './routes/setup/setup';

import { userData } from './assets/organizerList';

import './App.css';

const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
const ENDPOINT_URL = process.env.REACT_APP_ENDPOINT_URL;

export const custom_header = async () => {
  return { Authorization: await localStorage.getItem('jwt') };
};

API.configure({
  endpoints: [
    {
      name: 'treehacks',
      endpoint: ENDPOINT_URL,
      custom_header: custom_header,
    },
  ],
});

export function parseJwt(token) {
  var base64UrlSplit = token.split('.');
  if (!base64UrlSplit) return null;
  const base64Url = base64UrlSplit[1];
  if (!base64Url) return null;
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

function findNameByEmail(email) {
  try {
    const user = userData.users.find(
      (user) => user.email.toLowerCase() === email.toLowerCase()
    );
    return user ? user.name : null;
  } catch (error) {
    console.error('Error searching for email:', error);
    throw error;
  }
}

function getCurrentUser() {
  const jwt = getJwt();
  if (jwt) {
    // Verify JWT here.
    const parsed = parseJwt(jwt);
    if (!parsed) {
      console.log('JWT invalid');
    } else if (new Date().getTime() / 1000 >= parseInt(parsed.exp)) {
      console.log('JWT expired');
      // TODO: add refresh token logic if we want here.
    } else {
      let attributes = {
        name: parsed['name'],
        email: parsed['email'],
        email_verified: parsed['email_verified'],
        'cognito:groups': parsed['cognito:groups'],
        isOrganizer: parsed['cognito:groups'].includes('organizers_current'),
        isLeadership:
          parsed['cognito:groups'].includes('leadership_current') ||
          parsed['cognito:groups'].includes('admin'),
      };
      if (attributes.isOrganizer) {
        let name = findNameByEmail(parsed['email']);

        attributes = { ...attributes, name: name };

        return {
          username: parsed['sub'],
          attributes,
        };
      } else {
        return {
          error: 'Access restricted. Scan is only for organizers.',
        };
      }
    }
  }
  throw new Error('No current user');
}

function getJwt() {
  return localStorage.getItem('jwt');
}

function logout() {
  localStorage.removeItem('jwt');
  window.location.href = `${LOGIN_URL}/logout?redirect=${window.location.href}`;
}

function login() {
  window.location.href = `${LOGIN_URL}?redirect=${window.location.href}`;
}

const hash = queryString.parse(window.location.hash);
if (hash && hash.jwt) {
  localStorage.setItem('jwt', hash.jwt);
  window.location.hash = '';
}

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('tkn');

    // if an admin isn't registering an account
    if (!token)
      try {
        setUser(getCurrentUser());
      } catch (e) {
        login();
      }
  }, []);

  if (user === null) {
    return (
      <div className=''>
        <p className={['text-center text-xl mt-10 text-tree-green'].join(' ')}>
          Redirecting to login...
        </p>
      </div>
    );
  } else if (user.error) {
    return (
      <div className=''>
        <p className={['text-center text-xl mt-10 text-red-600'].join(' ')}>
          {user.error}
        </p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          element={
            <Nav
              user={user}
              logout={logout}
            />
          }>
          {/* Main routes */}
          <Route
            path='/'
            element={<Home user={user} />}
          />
          <Route
            path='/hacker'
            element={<Hacker user={user} />}
          />
          <Route
            path='/mentor'
            element={<Mentor user={user} />}
          />
          <Route
            path='/judge'
            element={<Judge user={user} />}
          />
          <Route
            path='/workshops'
            element={<Workshops user={user} />}
          />
          <Route
            path='/hardware'
            element={<Hardware user={user} />}
          />
          <Route
            path='/boba'
            element={<Boba user={user} />}
          />
          <Route
            path='/setup'
            element={<Setup user={user} />}
          />
          <Route
            path='/admin'
            element={<Admin user={user} />}
          />

          {/* 404 Not Found */}
          <Route
            path='*'
            element={
              <div className='flex h-[calc(100vh-80px)] items-center justify-center'>
                <h1 className='text-2xl text-slate-500'>Page not found</h1>
              </div>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
